import React, { useMemo } from 'react';
import { ModalComponent } from 'components';
import { EnrollResponseDataType } from 'types';
import { EnrollQuery, EventAdditionalQuery } from 'queries';
import { getQuestionResponse } from 'utils/question';

interface Props {
  eventId: string;
  data: EnrollResponseDataType | null;
  onClose: () => void;
}

function ViewModal({ eventId, data, onClose }: Props) {
  const { data: res } = EnrollQuery.useGetResponse(
    data?.userId || 1,
    data?.enrollId || 1,
    data !== null,
  );

  const { data: additional } = EventAdditionalQuery.useGet(eventId);
  const questions = useMemo(
    () =>
      getQuestionResponse(additional?.questions || [], res?.additional || []),
    [res, additional],
  );

  if (!data || !res) return null;

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal
          title="추가정보"
          handleClose={onClose}
          footer={<></>}
        >
          <div css={{ maxWidth: '50vw' }}>
            {questions?.map(
              (q: { id: number; response: string; title: string }) => (
                <div
                  key={q.id}
                  css={{ '>p': { lineHeight: '1.4', wordBreak: 'keep-all' } }}
                >
                  <p css={{ margin: '12px 0', fontWeight: 'bold' }}>
                    {q.title}
                  </p>
                  <p css={{ margin: '12px 0 24px 0' }}>{q.response}</p>
                </div>
              ),
            )}
          </div>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default ViewModal;
